export type EventRegistrationFormId = 'td25' | 'hkte-2025' | 'kyouth-info-2025' | 'real-talk-2025'

type EventFormOptionType = {
  [id in EventRegistrationFormId]: any
}

// ----------------------------
// Other common forms
// ----------------------------

const yesOrNoOptions = ['Yes', 'No']

export type GeneralCandidateFormValues = {
  name: string
  email: string
  phone?: {
    value: string
    isValid: boolean
  }
  age: string
  currentEmployed: string
  highestQualification: string
  experienceYears: string
  careerTrack: string[]
  educationBackground: string
  universityType: string
  universityName: string
  hearUs: string[]
  subscribe: boolean
}

// ----------------------------
// KYOUTH SESSION INFO 2025
// ----------------------------

// ----------------------------
// KL CAREER FAIR 2025
// ----------------------------

// JOB-SEEKERS
const qualificationOptions = ['Diploma or equivalent', 'Degree', `Master's`, 'PhD']
const experienceOptions = ['0-1 year', '1-3 years', '3-5 years', '5-10 years', '10 years and above']
const trackOptions = [
  `Software Engineering`,
  `Data Science`,
  `AI/ML`,
  `UX/UI Designer`,
  `Product/Project Manager`,
  `Digital Marketing`,
  `Cybersecurity`,
  `Tech Sales`,
  `Account Management`,
  `Tech Consulting`,
  `System Integration`,
  `IT Support`,
  `Networking/System Admin`,
  `Content & Multimedia`
]
const educationOptions = [
  `Engineering`,
  `Computer Science, Cybersecurity & IT`,
  `Business. Management, Finance & Accounting`,
  `Arts & Humanities`,
  `Social Sciences`,
  `Mathematics`,
  `Natural Sciences`,
  `Legal`
  //   `Others (please specify)`
]
const universityLocationOptions = ['Local', 'Overseas']
const hearOptions = [
  'TalentLabs social media',
  'Partnership (influencers / sponsored content)',
  'Word-of-mouth',
  'University'
  //   'Others'
]
const hearOptions2 = [
  'Instagram',
  'TikTok',
  'Facebook',
  'Linkedin',
  'XHS',
  'Media Partnership',
  'Others'
]

// EXHIBITORS
const companyTypeOptions = [
  `MNC (Multinational Corporation)`,
  `GLC (Government Linked Company)`,
  `PLC (Public Listed Company)`,
  `Conglomerate `,
  `Financial Institution`,
  `Family-Owned Business`,
  `NGOs / Non-Profits`,
  `Educational Institutions`,
  `SME (1-100 Employees)`,
  `SME (>100 Employees)`,
  `Startup (Series B - Pre IPO)`,
  `Startup (Pre-seed - Series A)"`
]
const industryOptions = [
  `Financial Services`,
  `GBS & Shared Services`,
  `Telecommunications`,
  `Professional Services`,
  `IT - Hardware`,
  `IT - Software`,
  `Commerce & Retail`,
  `Healthcare`,
  `Energy & Utilities`,
  `Manufacturing`,
  `Public Sector & GLC`,
  `Real Estate & Hospitality`,
  `Logistics, Mobility & Supply Chain`,
  `Education`,
  `Media & Entertainment `,
  `Agriculture`
  //   `Others (please specify)`
]
const supportOptions = [
  `Recruitment Solutions`,
  `Training & Development`,
  `Job Advertisements`,
  `Events & Talent Engagements, Employer Branding`,
  `Outsource Talents `
]

// COMMUNITY
const communityTypeOptions = [
  `Student Association`,
  `University`,
  `Media Company`,
  `Trade Association`
  //   `Others (please specify)`
]
const partnershipOptions = [
  `Event Promotion Partnership`,
  `Content Creation Partnership`,
  `Volunteer Collaboration`,
  `Workshop/Seminar Collaboration`
  //   `Others (please specify)`
]

// ALL OPTIONS
export const formOptions: EventFormOptionType = {
  td25: {
    qualifications: qualificationOptions,
    career: yesOrNoOptions,
    experience: experienceOptions,
    tracks: trackOptions,
    education: educationOptions,
    university: universityLocationOptions,
    hear: hearOptions,
    type: companyTypeOptions,
    industry: industryOptions,
    support: supportOptions,
    communityType: communityTypeOptions,
    partnership: partnershipOptions
  },
  'hkte-2025': {
    employed: yesOrNoOptions,
    experience: experienceOptions,
    industry: [
      `Information Technology`,
      `Cybersecurity`,
      `Legal`,
      `Engineering`,
      `Business Services`
    ],
    qualification: qualificationOptions,
    education: educationOptions,
    location: universityLocationOptions,
    hear: hearOptions
  },
  'real-talk-2025': {
    employed: yesOrNoOptions,
    qualification: qualificationOptions,
    experience: experienceOptions,
    interest: trackOptions,
    education: educationOptions,
    location: universityLocationOptions,
    hear: hearOptions2
  },
  'kyouth-info-2025': {}
}
